import {toast} from '@/utilities/toast/toast'
import {useBugReporter} from '../hooks/useBugReporter'
import {useEnvironmentSnapshot} from '../hooks/useEnvironmentSnapshot'
import {BugReportFormValues, EnvironmentSnapshot} from '../types'
import {BugReporterDialog} from './BugReporterDialog/BugReporterDialog'

export const BugReporterProvider = () => {
    const bugReporter = useBugReporter()
    const getSnapshot = useEnvironmentSnapshot()

    const handleSubmit = async (values: BugReportFormValues, snapshot: EnvironmentSnapshot) => {
        const result = await bugReporter.submit(values, snapshot)
        if (result && !result.partialFailure) {
            toast.success(`Bug report ${result.issue.identifier} created`)
        }
        return result
    }

    return (
        <BugReporterDialog
            isOpen={bugReporter.isOpen}
            onClose={bugReporter.close}
            onSubmit={handleSubmit}
            isSubmitting={bugReporter.isSubmitting}
            submitError={bugReporter.submitError}
            getSnapshot={getSnapshot}
        />
    )
}
